import Helpers from '../helpers/helpers';


export default new class CatalogNav {
    constructor() {
        /* selectors */
        this.catalogNavigationSelector = '.catalog-navigation';
        this.catalogNavigationListSelector = '.catalog-navigation__list';
        this.catalogNavigationItemSelector = '.catalog-navigation__item';
        this.catalogNavigationLinkMobSelector = '.catalog-navigation__link';

        /* css classes */
        this.activeItemClass = '_active-item';
        this.categoryOpenedMobClass = '_category-opened-mobile';
    }

    init() {
        let isMobile = Helpers.isMobile();


        if(!isMobile) {
            this.setFirstItemActive();
            this.bindEventsDesktop();
        } else {
            this.bindEventsMobile();
        }
    }


    setFirstItemActive() {
        $(this.catalogNavigationListSelector).find('.catalog-navigation__item:first-child').addClass(this.activeItemClass);
    }

    bindEventsDesktop() {
        $(document)
            .on('mouseenter', this.catalogNavigationItemSelector, (e) => {
                let $item = $(e.currentTarget);

                $item.closest(this.catalogNavigationSelector).find(this.catalogNavigationItemSelector).removeClass(this.activeItemClass);
                $item.addClass(this.activeItemClass);
            });
    }

    bindEventsMobile() {
        $(document)
            .on('click', this.catalogNavigationLinkMobSelector, (e) => {
                e.preventDefault();

                let $mobileCategoryItem = $(e.currentTarget).parent();

                $($mobileCategoryItem).toggleClass(this.categoryOpenedMobClass);
            });
    }


};


// WEBPACK FOOTER //
// ./src/common/modules/catalog-navigation/catalog-navigation.js